import { useParams } from "react-router-dom";
import roles from "./rolesData";

export default function StudentLifeRoleBody() {
    const { role: roleSlug } = useParams();
    const role = roles.find((r) => r.slug === roleSlug);

    if (!role) {
        return (
            <div className="container py-5 text-center">
                <h1 className="fw-bold mb-3">Role not found</h1>
                <p className="text-muted mb-4">We don't recognize that role. Head back to see all roles.</p>
                <a href="/student-life" className="btn btn-primary">
                    Back to Student Life
                </a>
            </div>
        );
    }

    return (
        <div>
            {/* Hero */}
            <div style={{ backgroundColor: "#f3f4f6" }} className="py-5">
                <div className="container py-4">
                    {/* Breadcrumb */}
                    <nav className="mb-4">
                        <ol className="d-flex align-items-center gap-1 list-unstyled m-0 p-0" style={{ fontSize: "0.85rem" }}>
                            <li>
                                <a href="/" className="text-muted text-decoration-none d-inline-flex align-items-center">
                                    <span className="material-icons" style={{ fontSize: "1rem" }}>home</span>
                                </a>
                            </li>
                            <li><span className="material-icons text-muted" style={{ fontSize: "1rem" }}>chevron_right</span></li>
                            <li>
                                <a href="/student-life" className="text-muted text-decoration-none">Student Life</a>
                            </li>
                            <li><span className="material-icons text-muted" style={{ fontSize: "1rem" }}>chevron_right</span></li>
                            <li className="fw-semibold" style={{ color: "#111" }}>{role.title}</li>
                        </ol>
                    </nav>

                    <div className="row align-items-start g-5">
                        <div className="col-12 col-lg-7">
                            <p
                                className="fw-semibold text-uppercase mb-2"
                                style={{ color: "#3769B9", letterSpacing: "0.08em", fontSize: "0.82rem" }}
                            >
                                {role.label}
                            </p>
                            <h1 className="fw-bold mb-3" style={{ fontSize: "clamp(2.2rem, 5vw, 3.5rem)", lineHeight: 1.1 }}>
                                {role.title}
                            </h1>
                            <p className="fw-semibold mb-4" style={{ fontSize: "clamp(1.05rem, 2vw, 1.2rem)", color: "#444" }}>
                                {role.tagline}
                            </p>
                            <p className="text-muted mb-5" style={{ fontSize: "clamp(1rem, 1.8vw, 1.1rem)", maxWidth: "540px", lineHeight: 1.7 }}>
                                {role.description}
                            </p>
                            <a
                                href="/apply"
                                className="btn btn-lg btn-danger d-inline-flex align-items-center gap-2"
                            >
                                Apply as {role.title} <span className="material-symbols-outlined">arrow_forward</span>
                            </a>
                        </div>

                        {/* Owns section */}
                        <div className="col-12 col-lg-5">
                            <div
                                className="rounded-3 p-4"
                                style={{ backgroundColor: "#fff", border: "1.5px solid #e5e7eb" }}
                            >
                                <p
                                    className="fw-bold text-uppercase mb-3"
                                    style={{ fontSize: "0.75rem", letterSpacing: "0.08em", color: "#3769B9" }}
                                >
                                    What you own
                                </p>
                                <ul className="list-unstyled m-0 space-y-2">
                                    {role.owns.map((item, i) => (
                                        <li key={i} className="d-flex align-items-start gap-2 mb-2">
                                            <span
                                                className="material-icons flex-shrink-0 mt-1"
                                                style={{ fontSize: "1rem", color: "#3769B9" }}
                                            >
                                                check_circle
                                            </span>
                                            <span style={{ fontSize: "0.95rem", color: "#333" }}>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Detail Blurbs */}
            <div className="py-5">
                <div className="container py-3">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-7">
                            {role.detailBlurb.map((paragraph, i) => (
                                <p
                                    key={i}
                                    className="mb-4"
                                    style={{ fontSize: "clamp(1rem, 1.8vw, 1.1rem)", lineHeight: 1.8, color: "#444" }}
                                >
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Other Roles */}
            <div className="py-5" style={{ backgroundColor: "#f3f4f6" }}>
                <div className="container py-3">
                    <h2 className="fw-bold mb-4 text-center" style={{ fontSize: "clamp(1.3rem, 2.5vw, 1.7rem)" }}>
                        Explore other roles
                    </h2>
                    <div className="row g-3 justify-content-center">
                        {roles
                            .filter((r) => r.slug !== role.slug)
                            .map((r) => (
                                <div key={r.slug} className="col-auto">
                                    <a
                                        href={`/student-life/${r.slug}`}
                                        className="btn btn-secondary d-inline-flex align-items-center gap-1"
                                        style={{ fontSize: "0.88rem" }}
                                    >
                                        {r.title}
                                    </a>
                                </div>
                            ))}
                    </div>
                    <div className="text-center mt-4">
                        <a href="/student-life" className="text-muted text-decoration-none" style={{ fontSize: "0.9rem" }}>
                            ← Back to Student Life
                        </a>
                    </div>
                </div>
            </div>

            {/* CTA */}
            <div className="py-5" style={{ backgroundColor: "#3769B9" }}>
                <div className="container text-center text-white py-3">
                    <h2 className="fw-bold mb-3" style={{ fontSize: "clamp(1.4rem, 3vw, 2rem)" }}>
                        Ready to own the {role.title} seat?
                    </h2>
                    <p
                        className="mb-4 mx-auto"
                        style={{ opacity: 0.8, fontSize: "clamp(0.95rem, 1.8vw, 1.1rem)", maxWidth: "440px" }}
                    >
                        Applications are open. Cohorts are small — seats go fast.
                    </p>
                    <a
                        href="/apply"
                        className="btn btn-lg btn-danger d-inline-flex align-items-center gap-2"
                    >
                        Apply Now <span className="material-symbols-outlined">arrow_forward</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
